module.exports = __webpack_public_path__ + "79522e8031ab50c7d321c41ad6176b0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/index_01.jpg
// module id = 8MMS
// module chunks = 0